export const ru = {
  substitutions: {
    nextPreview: 'Следующая отправка: № {{counter}}, дата в тексте — {{date}}',
    title: 'Автоподстановки',
    hint: 'Номер выпуска и дата меняются при отправке. Вставьте переменную в название или текст.',
    start: 'Начать с',
    step: 'Шаг',
    invalid:
      'Для {counter} включите автоподстановки. Начало: целое от 0 до 1 000 000 000, шаг: от 1 до 1 000 000. Сдвиг даты: например {date:+13d}.',
    sequence: 'Ближайший выпуск: {{current}} → затем {{next}}',
    offset: 'Сдвиг даты, дней',
    destination: 'Куда вставить',
    toTitle: 'В название',
    toMessage: 'В сообщение',
    insertCounter: 'Счётчик',
    insertDate: 'Дата',
    policy:
      'Предпросмотр и пауза не расходуют номер. Ручная отправка — новый выпуск. При ошибке номер сохраняется за попыткой; повтор использует его же. Расписание не меняется.',
  },
  polls: {
    title: 'Голосование',
    add: 'Добавить голосование',
    hint: 'Опрос появится в Telegram под сообщением. Можно предложить варианты и разрешить участникам добавлять свои.',
    question: 'Вопрос',
    questionPlaceholder: 'Что выберем?',
    options: 'Варианты ответа',
    option: 'Вариант {{number}}',
    removeOption: 'Удалить вариант {{number}}',
    addOption: 'Добавить вариант',
    allowAdding: 'Участники могут добавлять свои варианты',
    addingHint: 'Работает в открытом голосовании: Telegram покажет, кто проголосовал.',
    multiple: 'Можно выбрать несколько вариантов',
    anonymous: 'Анонимное голосование',
    public: 'Открытое голосование',
    ownOptionHint: 'Можно добавить свой вариант в Telegram',
    preview: 'Предпросмотр голосования',
    duplicates: 'Варианты должны отличаться друг от друга.',
    invalid: 'Заполните вопрос и от 2 до 12 разных вариантов ответа.',
  },
  labels: {
    role: 'Роль',
    roles: {
      owner: 'Владелец',
      admin: 'Администратор',
      moderator: 'Модератор',
      viewer: 'Наблюдатель',
      unknown: 'Роль не указана',
    },
    chatTypes: {
      private: 'Личный чат',
      group: 'Группа',
      supergroup: 'Супергруппа',
      channel: 'Канал',
      unknown: 'Чат',
    },
  },
  workspace: {
    memberBirthday: 'День рождения · {{date}}',
    memberRoleTitle: 'Роль · {{name}}',
    memberRoleError: 'Не удалось изменить роль. Попробуйте ещё раз.',

    needsTitleAndMessage: 'Добавьте заголовок и сообщение, чтобы перейти к получателям.',
    needsTitle: 'Добавьте заголовок, чтобы перейти дальше.',
    needsMessage: 'Добавьте текст или заполненный rich-блок, чтобы перейти дальше.',
    needsRecipients: 'Выберите хотя бы одну группу для отправки.',
    holdForActions: 'Удерживайте карточку, чтобы открыть действия',

    quickShort: { hour: 'Через час', tomorrow: 'Завтра, 09:00', monday: 'Пн, 09:00' },
    memberSearch: 'Поиск участников',
    journalSearch: 'Поиск в журнале',
    filters: 'Фильтры',
    searchToggle: 'Поиск сообщений',
    statusLabel: 'Статус',
    resetFilters: 'Сбросить',
    typeLabel: 'Тип сообщения',
    types: {
      task: 'С подтверждением',
      birthday: 'День рождения',
      work: 'Рабочее',
      custom: 'Другое',
    },
    messageHeading: 'Заголовок сообщения',
    quick: { hour: 'Через час', tomorrow: 'Завтра в 09:00', monday: 'В понедельник в 09:00' },
    title: 'Команда на связи',
    subtitle: 'Сообщения команде и ближайшие отправки',
    upcoming: 'Ближайшие отправки',
    upcomingHint: 'Время указано в часовом поясе уведомления',
    noUpcoming: 'Ближайших отправок нет',
    noUpcomingHint: 'Создайте сообщение или откройте список, чтобы настроить расписание.',
    allReminders: 'Все уведомления',
    create: 'Создать сообщение',
    attention: 'Требуют внимания',
    summary: 'Обзор доставки',
    loadError: 'Не удалось загрузить данные. Проверьте соединение и попробуйте ещё раз.',
    retry: 'Повторить',
    resultCount: 'Найдено: {{count}}',
    sort: 'Порядок уведомлений',
    newest: 'Сначала новые',
    bySchedule: 'По следующей отправке',
    byTitle: 'По названию',
    actions: 'Действия с уведомлением',
    rich: 'Rich-сообщение',
    copy: 'Создать похожее',
    copyHint:
      'Текст, оформление и получатели скопированы. Выберите дату и проверьте предпросмотр перед сохранением.',
    steps: 'Шаги создания сообщения',
    step: { message: 'Сообщение', recipients: 'Получатели', preview: 'Проверка' },
    messageHint:
      'Подготовьте сообщение и выберите время. Перед отправкой вы увидите предпросмотр Telegram.',
    previewHint: 'Проверьте оформление, получателей и время отправки.',
    recipientsHint: 'Выберите группы и ответственных за уведомление.',
  },

  header: {
    analyticsHint: 'Отправки и активность команды',
    templatesHint: 'Готовые тексты для новых сообщений',
    spaceLabel: 'Рабочее пространство',

    brand: 'IRL',
    title: 'На связи с командой',
    menu: 'Меню',
    settings: 'Настройки',
  },
  nav: {
    home: 'Главная',
    analytics: 'Аналитика',
    reminders: 'Сообщения',
    chats: 'Группы',
    logs: 'Журнал',
    audit: 'Аудит',
    templates: 'Шаблоны',
    settings: 'Настройки',
    createReminder: 'Создать уведомление',
  },
  auth: {
    accessDenied: 'Доступ запрещён',
    permissionDeniedHint: 'У вас нет прав для просмотра этого раздела.',
    authError: 'Ошибка авторизации',
    telegramOnlyTitle: 'Только через Telegram',
    telegramOnlyDescription:
      'Панель администратора доступна только как Mini App внутри Telegram. Откройте бота и нажмите кнопку меню.',
    telegramInitMissing:
      'Telegram не передал данные авторизации. Закройте Mini App и откройте снова. Если ошибка повторяется — проверьте домен в @BotFather.',
    networkError: 'Не удалось связаться с сервером. Проверьте интернет и попробуйте снова.',
    devHint:
      'Локальный режим: в .env нужны DEV_AUTH_BYPASS=true и DEV_AUTH_USER_ID=100000001, затем pnpm db:seed и перезапуск API',
    devBypassError:
      'Локальный режим: включите DEV_AUTH_BYPASS=true в .env, перезапустите API и выполните pnpm db:seed',
  },
  deliveryMessage: {
    title: 'Изменить сообщение',
    edit: 'Редактировать отправленное сообщение',
    hint: 'Изменится только это сообщение в Telegram. Шаблон и будущие отправки останутся прежними.',
    approximate:
      'Текст восстановлен из шаблона и может отличаться от отправленного сообщения. Проверьте его целиком перед сохранением.',
    loading: 'Загружаем текст сообщения…',
    loadError: 'Не удалось загрузить текст сообщения. Попробуйте ещё раз.',
    saveError:
      'Не удалось изменить сообщение. Проверьте текст и доступ бота к сообщению, затем повторите сохранение.',
    validationError: 'Введите текст сообщения: от 1 до 4096 символов.',
    saved: 'Отправленное сообщение изменено',
    editedAt: 'Изменено {{date}}',
  },
  common: {
    clear: 'Очистить поиск',
    moveUp: 'Переместить вверх',
    moveDown: 'Переместить вниз',
    save: 'Сохранить',
    saving: 'Сохранение…',
    back: 'Назад',
    next: 'Далее',
    all: 'Все',
    open: 'Открыть',
    new: 'Новый',
    edit: 'Редактировать',
    delete: 'Удалить',
    preview: 'Превью',
    search: 'Поиск…',
    noData: 'Нет данных',
    selectChat: 'Выберите группу',
    allChats: 'Все группы',
    dashboard: 'Дашборд',
    enabled: 'Включено',
    active: 'Активна',
    inactive: 'Неактивна',
    group: 'Группа',
    groupUnknown: 'Группа не указана',
    pause: 'Пауза',
    pausing: 'Пауза…',
    resume: 'Возобновить',
    start: 'Запустить',
    starting: 'Запуск…',
    sending: 'Отправка…',
    sendNow: 'Отправить сейчас',
    sendNowTitle: 'Отправить сейчас?',
    sendNowConfirm:
      'Сообщение сразу уйдёт в выбранные группы. Запланированное расписание не изменится.',
    sendFailed: 'Не удалось отправить',
    deleting: 'Удаление…',
    activate: 'Активировать',
    now: 'Сейчас',
    actions: 'Действия',
    close: 'Закрыть',
    optional: 'опц.',
    server: 'сервер',
    syncing: 'Синхронизация…',
    retry: 'Повторить',
    loadError: 'Не удалось загрузить',
    saveError: 'Ошибка сохранения',
    sendError: 'Ошибка отправки',
    deleteConfirm: 'Удалить «{{title}}»?',
    deleteReminderTitle: 'Удалить уведомление?',
    deleteReminderConfirm: 'Удалить уведомление?',
    deleteReminderConfirmDetail:
      '«{{title}}» будет удалено без возможности восстановления. Расписание и история отправок тоже исчезнут.',
    deleteTemplateConfirm: 'Удалить шаблон «{{name}}»?',
    selectItem: 'Выбрать {{label}}',
    serverTime: 'Текущее время сервера',
    previewPlaceholder: 'Текст уведомления появится здесь',
    drafts: 'Черновики',
    paused: 'На паузе',
    archive: 'Архив',
    errors: 'Ошибки',
    cancel: 'Отмена',
    done: 'Готово',
    change: 'Изменить',
    settingsSaved: 'Настройки сохранены',
    selectedCount: '{{count}} выбрано',
    year: 'Год',
    name: 'Название',
    style: 'Стиль',
    body: 'Текст',
    message: 'Сообщение',
    text: 'Текст',
    timezone: 'Таймзона',
    timezoneFull: 'Часовой пояс',
    timezoneNow: 'Сейчас в этой таймзоне: {{time}}',
    timezoneNowLabel: 'Сейчас в этой таймзоне',
    notes: 'Заметки',
    action: 'Действие',
    frequency: 'Периодичность',
    type: 'Тип',
  },
  badge: {
    active: 'Активно',
    paused: 'Пауза',
    draft: 'Черновик',
    inactive: 'Неактивно',
    archived: 'Архив',
    sent: 'Доставлено',
    failed: 'Ошибка',
    pending: 'В очереди',
    cancelled: 'Отменено',
    scheduled: 'В очереди',
    due_no_job: 'Нет задачи',
    misconfigured: 'Ошибка расписания',
    awaiting_activation: 'Ожидает запуска',
    not_applicable: '—',
  },
  confirmations: {
    buttonSettings: 'Кнопки ответа',
    actionNames: {
      done: 'Подтверждение',
      decline: 'Отказ',
    },
    buttonLabel: 'Надпись на кнопке',
    requireText: 'Запрашивать обязательный текст',
    responsePrompt: 'Вопрос участнику',
    responsePromptPlaceholder: 'Например: предложите своё название спринта',
    buttonSettingsHint:
      'Оставьте хотя бы одну кнопку. Если запрашивается текст, ответ засчитывается после сообщения участника.',
    responseReceived: 'Ответ получен',
    awaitingDelivery: 'Срок ответа начнётся после доставки уведомления.',
    syncPending: 'Ответы сохранены. Обновляем кнопки в Telegram…',
    syncUnavailable: 'Сообщение Telegram недоступно для обновления. Ответы сохранены здесь.',

    invalidSettings:
      'Проверьте срок ответа и кнопки. Нужна хотя бы одна кнопка с непустой подписью; при включённых повторах интервал должен быть короче срока ответа.',
    title: 'Подтверждение участников',
    audience: 'От кого ждём ответ',
    all: 'Все известные боту',
    selected: 'Выбрать участников',
    knownHint:
      'Бот знает участников из сообщений, событий группы и синхронизации. Полный список Telegram ему недоступен.',
    interval: 'Напоминать каждые, мин',
    repeatEnabled: 'Повторять до ответа',
    singleSend: 'Одно сообщение с кнопками подтверждения, без повторных напоминаний.',
    deadline: 'Ждать ответа, часов',
    fieldsHint:
      'По умолчанию отправляется одно сообщение. Если включить повторы, они прекращаются после ответа участника, срока ответа или паузы уведомления.',
    groupsHint: 'Выберите группы на следующем шаге — затем можно указать участников.',
    empty: 'Бот ещё не знает участников. Попросите их написать в группе и обновите список.',
    pending: 'Ожидаем',
    done: 'Сделал',
    declined: 'Не будет',
    progress: 'Ответы участников',
    noRequests: 'Ответы появятся после отправки уведомления.',
    expired: 'Срок ответа истёк',
    paused: 'Напоминания на паузе',
    needRecipients: 'Выберите хотя бы одного участника.',
    previewHint:
      'В Telegram появятся настроенные кнопки. Если для кнопки требуется текст, бот попросит участника ответить на его сообщение.',
  },
  settings: {
    appearance: 'Оформление',
    darkTheme: 'Тёмная тема',
    themeHint: 'Мягкий свет или глубокие вечерние оттенки',
    themeAuto: 'Как в Telegram',

    title: 'Настройки',
    profile: 'Профиль',
    about: 'О приложении',
    aboutDescription: 'IRL — Info / Release / Lifecycle',
    version: 'Версия',
    updated: 'Собрано',
    changelog: 'История изменений',
    language: 'Язык',
    languageDescription: 'Интерфейс Mini App',
    profileHint: 'Аккаунт Telegram',
    localeRu: 'Русский',
    localeEn: 'English',
    integrations: 'Интеграции',
    telegramApiTitle: 'Расширенный доступ к Telegram API',
    telegramApiDescription: 'Для выгрузки участников и других MTProto-сценариев',
    telegramApiManage: 'Настроить',
    telegramApiViewStatus: 'Статус подключения',
    telegramApiConnected: 'Подключено',
    telegramApiNotConnected: 'Не настроено',
  },
  telegramApi: {
    optionalBadge: 'Необязательно',
    wizard: {
      intro: 'Обзор',
      guide: 'Инструкция',
      form: 'Ввод',
      stepOf: 'Шаг {{current}} из {{total}}',
      done: 'Готово',
    },
    formSecurityNote: 'Секрет хранится только на сервере, в браузере не остаётся.',
    sourceLabel: 'Источник: {{source}}',
    sourceEnv: 'окружение (.env)',
    sourceDb: 'настройки Mini App',
    title: 'Расширенный доступ к Telegram API',
    introLead:
      'Mini App уже авторизует вас через Telegram автоматически. api_id и api_hash нужны только для расширенных сценариев интеграции.',
    introSecondary: 'Это необязательный шаг. Большинство функций Mini App работает и без него.',
    benefitsTitle: 'Что это даст',
    benefitExport: 'Полная выгрузка участников группы через MTProto',
    benefitMtproto: 'Расширенные сценарии, недоступные через обычный Bot API',
    importantTitle: 'Что важно знать',
    importantOptional: 'Обычная авторизация Mini App уже работает без этих данных.',
    importantMiniAppAuth: 'Эти данные нужны только для расширенного доступа.',
    importantSecret: 'api_hash — секрет. Не передавайте его другим людям.',
    openMyTelegram: 'Открыть my.telegram.org',
    setupLater: 'Настроить позже',
    guideTitle: 'Как получить данные',
    guideLead: 'Следуйте шагам на официальном сайте Telegram. Это займёт пару минут.',
    guideStep: {
      login: 'Войдите на my.telegram.org по номеру телефона',
      openTools: 'Откройте раздел «API development tools»',
      openToolsHint: 'Обычно в меню после входа',
      copyCredentials: 'Создайте приложение и скопируйте api_id и api_hash',
    },
    externalSiteTitle: 'Официальный сайт Telegram',
    externalSiteHint:
      'Вы перейдёте на внешний сайт Telegram. Данные вводятся там, а секреты хранятся только на нашем сервере.',
    hashWarningTitle: 'Держите api_hash в секрете',
    hashWarningBody: 'Не отправляйте api_hash в чаты, скриншоты и сторонним сервисам.',
    guideReady: 'Данные скопировал — ввести',
    formTitle: 'Введите данные API',
    formLead:
      'Значения с my.telegram.org. api_hash хранится только на сервере и не сохраняется в браузере.',
    apiIdLabel: 'API ID',
    apiIdHint: 'Числовой идентификатор приложения из my.telegram.org',
    apiHashLabel: 'API Hash',
    apiHashHint: 'Секретный ключ приложения. Хранится только на сервере.',
    showHash: 'Показать API Hash',
    hideHash: 'Скрыть API Hash',
    saveButton: 'Проверить и сохранить',
    saving: 'Сохранение…',
    saveSuccess: 'Данные Telegram API сохранены',
    saveError: 'Не удалось сохранить данные. Проверьте введённые значения.',
    statusTitle: 'Статус подключения',
    statusLead: 'Подключение к расширенному Telegram API для MTProto-сценариев.',
    statusConnected: 'Подключено',
    statusDisconnected: 'Не подключено',
    envManagedTitle: 'Управляется окружением',
    envManagedHint:
      'TELEGRAM_API_ID и TELEGRAM_API_HASH заданы в .env сервера. Изменить их через Mini App нельзя.',
    verificationLabel: 'Проверка',
    verificationVerified: 'Подключение проверено',
    verificationSaved: 'Сохранено',
    verificationUnverified: 'Не проверено',
    connectedByLabel: 'Подключил',
    connectedAtLabel: 'Подключено',
    updatedAtLabel: 'Обновлено',
    updateButton: 'Обновить',
    verifyButton: 'Проверить подключение',
    verifying: 'Проверка…',
    verifySuccess: 'Подключение успешно проверено',
    verifyError: 'Не удалось проверить подключение',
    dangerZoneTitle: 'Отключить интеграцию',
    dangerZoneHint:
      'Удалит сохранённые на сервере api_id и api_hash. Функции MTProto перестанут работать, пока не настроите снова.',
    disconnectButton: 'Отключить',
    disconnecting: 'Отключение…',
    disconnectSuccess: 'Интеграция отключена',
    disconnectError: 'Не удалось отключить интеграцию',
    loadError: 'Не удалось загрузить статус подключения',
    exportSetupCta: 'Настроить Telegram API',
  },
  feedback: {
    saved: 'Сохранено',
    savedAt: 'Сохранено в {{time}}',
    settingsUpdated: 'Настройки обновлены',
    templateApplied: 'Шаблон применён',
    updated: 'Изменения сохранены',
    reminderCreated: 'Уведомление создано',
    reminderSent: 'Уведомление отправлено',
    sent: 'Отправлено',
    actionFailed: 'Не удалось выполнить действие',
  },
  dashboard: {
    title: 'Панель',
    subtitle: 'Операционная сводка',
    analyticsLink: 'Аналитика',
    periods: { today: 'Сегодня', '7d': '7 дней', '30d': '30 дней' },
    metrics: {
      sent: 'Отправлено',
      delivered: 'Доставлено',
      errors: 'Ошибки',
      groups: 'Группы',
      activeGroups: 'активных',
    },
    alerts: 'Требуют внимания',
    recentActivity: 'Активность доставки',
    allLogs: 'Все логи',
    viewLogs: 'Открыть логи',
    noDeliveries: 'Пока нет отправок',
  },
  analytics: {
    title: 'Аналитика',
    subtitle: 'Read-модели по группам',
    dashboardLink: 'Dashboard',
    periods: { today: 'Сегодня', '7d': '7 дней', '30d': '30 дней' },
    metrics: {
      reminders: 'Уведомления',
      groups: 'Группы',
      inScope: 'в выборке',
      delivery: 'доставка',
      sent: 'отправлено',
    },
    timeline: 'Динамика',
    timelineHint: 'Уведомления и дни рождения по дням',
    noTimeline: 'Нет данных за период',
    byChat: 'По группам',
    noActivity: 'Нет активности',
    remindersShort: 'уведомл.',
    errorsShort: 'ошибок',
  },
  pages: {
    reminders: 'Уведомления',
    createReminder: 'Создать уведомление',
    selectGroups: 'Выбор групп',
    previewSend: 'Превью и отправка',
    editReminder: 'Редактировать уведомление',
    chats: 'Группы',
    logs: 'Журнал',
    templates: 'Шаблоны',
    editTemplate: 'Редактировать шаблон',
    createTemplate: 'Создать шаблон',
    greetings: 'Приветствия',
    members: 'Участники',
    membersEmpty:
      'Участники появятся после синхронизации с Telegram. Админы группы подтягиваются сразу; остальные — когда напишут в чат или зайдут в группу.',
    globalAdminBadge: 'Глобальный администратор (WEBAPP_ADMINS)',
    audit: 'Аудит',
    birthdaySettings: 'Настройки ДР',
    birthdayMembers: 'Участники',
    birthdayTemplates: 'Шаблоны поздравлений',
    birthdayTemplateEdit: 'Редактировать шаблон',
    birthdayTemplateNew: 'Новый шаблон',
    birthdayPreview: 'Превью поздравления',
    birthdayLogs: 'Журнал поздравлений',
  },
  chats: {
    search: 'Поиск групп...',
    subtitle: 'Управление группами и быстрые действия',
    primaryAction: 'Уведомления',
    moreActions: 'Ещё действия',
    filters: { all: 'Все', active: 'Активные', inactive: 'Неактивные' },
    emptyTitle: 'Нет подключённых групп',
    emptyDescription:
      'Добавьте бота в группу и назначьте администратором, затем откройте бота в личке',
    noTitle: 'Без названия',
    remindersCount: '{{count}} уведомлений',
    detailSubtitle: 'Разделы и настройки группы',
    actionsTitle: 'Разделы',
    notFound: 'Группа не найдена',
    notFoundHint: 'Возможно, у вас больше нет доступа к этой группе.',
    avatarAlt: 'Аватар группы {{title}}',
    dangerZoneTitle: 'Опасная зона',
    actions: {
      reminders: 'Уведомления',
      activity: 'Журнал активности',
      members: 'Участники',
      greetings: 'Приветствия',
    },
  },
  reminders: {
    loadingMore: 'Загружаем ещё уведомления…',
    allLoaded: 'Все уведомления загружены',

    schedulingErrorReasons: {
      missing_schedule:
        'Следующий запуск не назначен. Проверьте расписание и запустите уведомление.',
      once_in_past:
        'Разовая дата уже прошла, отправка для неё не подтверждена. Укажите новую дату и запустите уведомление.',
      period_ended:
        'Срок действия расписания закончился. Измените дату окончания и запустите уведомление.',
      no_future_run:
        'В заданном расписании не найден следующий запуск. Проверьте даты и параметры повторения.',
      invalid_schedule:
        'Не удалось рассчитать расписание. Проверьте дату, время и параметры повторения.',
    },
    noRepeatingSchedule:
      'Автоматическая отправка не запланирована. Можно отправить сейчас или выбрать новую дату.',
    onceCompleted:
      'Следующая автоматическая отправка не запланирована. Можно отправить сейчас или выбрать новую дату.',
    search: 'Поиск уведомлений...',
    subtitle: 'Список, фильтры и быстрые действия',
    createShort: 'Создать',
    empty: 'Уведомлений пока нет',
    emptySearch: 'Ничего не найдено',
    emptyHint: 'Создайте первое уведомление для рассылки в группы',
    noGroupsSearch: 'Группы не найдены',
    createFirst: 'Создать уведомление',
    groupsCount: 'Группы: {{count}}',
    deleteAll: 'Удалить все уведомления',
    deleteAllConfirm: 'Удалить все',
    deleteAllTitle: 'Удалить все уведомления группы?',
    deleteAllDescription:
      'Все уведомления группы «{{title}}» будут удалены без возможности восстановления — активные, черновики, на паузе и в архиве. Расписания тоже снимутся.',
    deleteAllHint: 'Необратимо удалит все уведомления этой группы, включая черновики и архив.',
    deleteAllSuccess: 'Удалено уведомлений: {{count}}',
    deleteAllEmpty: 'В этой группе нет уведомлений',
    filters: {
      all: 'Все',
      active: 'Активные',
      draft: 'Черновики',
      paused: 'На паузе',
      inactive: 'Неактивно',
      archived: 'Архив',
    },
    form: {
      createTitle: 'Создать уведомление',
      editTitle: 'Редактировать уведомление',
      titleLabel: 'Название уведомления',
      titlePlaceholder: 'Например, Обновление сервиса',
      bodyPlaceholder: 'Текст уведомления...',
      weekdayError: 'Выберите хотя бы один день недели',
      contentType: { text: 'Текст', photo: 'Фото', document: 'Документ' },
      sendMode: { now: 'Отправить сейчас', schedule: 'Запланировать' },
      sending: 'Отправка...',
      richFormatToggle: 'Конструктор блоков',
      richFormatHint: 'Заголовки, списки, таблицы и другое оформление',
      dragBlock: 'Перетащить блок',
    },
    richMedia: {
      photo: 'Фото',
      collage: 'Коллаж',
      slideshow: 'Слайдшоу',
      addPhoto: 'Добавить фото',
      addPhotos: 'Добавить фото',
      replace: 'Заменить',
      empty: 'Выберите изображение',
      emptyGroup: 'Добавьте одно или несколько фото',
      captionPlaceholder: 'Подпись (необязательно)',
      uploadFailed: 'Не удалось загрузить фото',
      previewError: 'Нет превью',
      photoAlt: 'Фото уведомления',
      removePhoto: 'Удалить фото',
      toolbar: {
        heading: 'Заголовок',
        paragraph: 'Параграф',
        list: 'Список',
        quote: 'Цитата',
        pullQuote: 'Выдел. цитата',
        table: 'Таблица',
        details: 'Детали',
        divider: 'Разделитель',
        dateTime: 'Дата/Время',
        code: 'Код',
        photo: 'Фото',
        collage: 'Коллаж',
        slideshow: 'Слайдшоу',
      },
    },
    detail: {
      history: 'История отправок',
      noHistory: 'Пока нет отправок',
      schedule: 'Расписание',
      targets: 'Группы',
      responsible: 'Ответственные',
      responsibleHint: 'Админы, назначенные на это уведомление',
      scheduleAt: '{{type}} в {{time}} ({{timezone}})',
      deliveryHistoryHint: 'Последние доставки по этому уведомлению',
      scheduledFor: 'Запланировано: {{date}}',
      deliveredAt: 'Доставлено: {{date}}',
      nextRunLabel: 'Следующий запуск',
      lastRunLabel: 'Последняя отправка',
      tabOverview: 'Обзор',
      tabDebug: 'Доставка / Debug',
    },
    notFound: 'Уведомление не найдено',
    formSubtitle: 'Настройте контент и расписание отправки',
    saveDraft: 'Сохранить черновик',
    sendSuccess: 'Сообщение отправлено в группу',
    nextRun: 'Следующий запуск: {{date}} · {{timezone}}',
    lastRun: 'Последняя отправка: {{date}}',
    schedulingHealth: 'Состояние очереди',
    reschedule: 'Пересоздать расписание',
    rescheduling: 'Пересоздание…',
    rescheduleHint:
      'Задача в очереди отсутствует. Пересоздайте расписание, чтобы восстановить отправку.',
    dueNoJobTitle: 'Задача в очереди отсутствует',
    misconfiguredTitle: 'Расписание не настроено',
    deliveryStatus: 'Доставка',
    lastDeliveryError: 'Последняя ошибка: {{error}}',
    queueState: 'Очередь: {{state}}',
    queueJobState: {
      delayed: 'отложена',
      waiting: 'в очереди',
      active: 'выполняется',
      completed: 'завершена',
      failed: 'ошибка',
      paused: 'на паузе',
      missing: 'не найдена',
    },
    scheduleMismatch: 'Расхождение очереди: {{reason}}',
    startDateLocal: 'Календарная дата: {{date}}',
    scheduleRevision: 'Ревизия расписания {{revision}}',
    noNextRun: 'Следующая отправка не запланирована',
    schedulingHealthHelp: {
      scheduled: 'Задача в очереди BullMQ. Отправка произойдёт автоматически в указанное время.',
      due_no_job:
        'Уведомление активно и время отправки рассчитано, но в BullMQ нет отложенной задачи. Нажмите «Пересоздать расписание» — сообщение сразу не уйдёт, только восстановится очередь.',
      misconfigured:
        'Уведомление неактивно из-за ошибки расписания. Исправьте причину и запустите его снова.',
      awaiting_activation:
        'Черновик с расписанием. Нажмите «Запустить», чтобы поставить в очередь.',
    },
    debug: {
      queue: {
        title: 'Состояние очереди',
        intro:
          'Планировщик хранит отложенную задачу в Redis (BullMQ). Когда наступает время, воркер отправляет сообщение в группы — без ручного вмешательства.',
        loadError: 'Не удалось загрузить состояние очереди',
        noData: 'Нет данных очереди',
        retry: 'Повторить',
        inSync: 'Синхронно',
        outOfSync: 'Рассинхрон',
        countdownLabel: 'До отправки',
        countdownRemaining: 'Осталось',
        countdownDue: 'Время наступило',
        countdownDueHint:
          'Задача в очереди должна запуститься в ближайшие секунды. Если отправки нет — проверьте воркер или пересоздайте задачу.',
        countdownDays: '{{count}} д',
        countdownHours: '{{count}} ч',
        countdownMinutes: '{{count}} мин',
        countdownSeconds: '{{count}} с',
        jobStateHelp: {
          delayed:
            'Задача отложена в Redis и сработает автоматически в запланированное время. Статус «отложена» — нормальное состояние для активного напоминания.',
          waiting: 'Задача в очереди и скоро будет обработана воркером.',
          active: 'Задача выполняется прямо сейчас — идёт отправка в группы.',
          completed:
            'Задача завершена. Если отправка прошла недавно, следующая появится после пересчёта расписания.',
          failed:
            'Задача завершилась с ошибкой. Проверьте историю доставки и при необходимости пересоздайте задачу.',
          paused: 'Задача на паузе в очереди — отправка приостановлена до возобновления.',
          missing:
            'В Redis нет задачи для этого напоминания. Отправка не произойдёт, пока задачу не пересоздадут.',
        },
        mismatch: {
          job_missing:
            'Время в базе рассчитано, но задача в Redis отсутствует. Нужно пересоздать задачу в очереди.',
          scheduled_for_mismatch:
            'Время в задаче Redis не совпадает с nextRunAt в базе. Возможна отправка по устаревшему слоту.',
          revision_mismatch:
            'Расписание менялось после постановки задачи — ревизия в Redis устарела.',
          missing_next_run_at:
            'Следующий запуск не задан в базе, хотя напоминание может быть активным.',
        },
        mismatchTitle: 'Рассинхрон очереди и базы',
        dbSourceTitle: 'База данных',
        dbSourceHint: 'Поле nextRunAt в MongoDB',
        redisSourceTitle: 'Очередь Redis',
        redisSourceHint: 'Отложенная задача BullMQ',
        jobNotFound: 'Задание не найдено',
        revision: 'Ревизия БД #{{db}}{{job}}',
        revisionJob: ' · задача #{{revision}}',
        technicalDetails: 'Технические детали',
        actionsTitle: 'Действия администратора',
        rescheduleButton: 'Пересоздать задачу',
        rescheduleHint:
          'Удалит старую задачу в Redis и создаст новую по текущему расписанию. Сообщение сразу не отправится.',
        rescheduleTitle: 'Пересоздать задачу в очереди?',
        rescheduleConfirm:
          'Будет пересчитан следующий запуск, увеличена ревизия расписания и заново создана отложенная задача в BullMQ. Сообщение в группы сейчас не уйдёт.',
        recalculateButton: 'Пересчитать расписание',
        recalculateHint:
          'Заново вычислит nextRunAt по правилам расписания и синхронизирует очередь, если время изменилось.',
        recalculateTitle: 'Пересчитать следующий запуск?',
        recalculateConfirm:
          'Следующая дата отправки будет вычислена заново по текущим настройкам расписания. Если время изменится, очередь обновится автоматически.',
        rescheduling: 'Пересоздание…',
        recalculating: 'Пересчёт…',
      },
      delivery: {
        title: 'Следующая доставка',
        loadError: 'Не удалось загрузить данные доставки',
        notFound: 'Напоминание не найдено',
        retry: 'Повторить',
        inSync: 'Синхронно',
        outOfSync: 'Рассинхрон',
        notScheduledTitle: 'Доставка не запланирована',
        notScheduledReason: 'Причина: {{reason}}',
        notScheduledDefault: 'Следующий запуск не задан — планировщик не знает, когда отправлять.',
        recalculate: 'Пересчитать',
        recalculating: 'Пересчёт…',
        dbSourceTitle: 'База данных',
        dbSourceHint: 'Поле nextRunAt в MongoDB',
        redisSourceTitle: 'Очередь Redis',
        redisSourceHint: 'Задание BullMQ в Redis',
        jobNotFound: 'Задание не найдено',
        mismatchHint:
          'Время в базе и в очереди не совпадают — возможна отправка по устаревшему слоту.',
        technicalDetails: 'Технические детали',
        copyScheduledForMs: 'Скопировать scheduledForMs',
      },
    },
    wizard: {
      step1: 'Шаг 1 из 3 — контент',
      step2: 'Шаг 2 из 3 — группы',
      step3: 'Шаг 3 из 3 — отправка',
      stepShort1: 'Контент',
      stepShort2: 'Группы',
      stepShort3: 'Отправка',
      progressShort: 'Шаг {{current}} из {{total}}',
      progress: 'Шаг {{current}} из {{total}} — {{step}}',
    },
    scheduleCard: {
      title: 'Расписание',
      description: 'Когда и как часто отправлять уведомление',
    },
    previewRuns: {
      title: 'Ближайшие запуски',
      description: 'Предпросмотр по текущим настройкам',
      today: 'Сегодня',
      tomorrow: 'Завтра',
      soon: 'Скоро',
      lessThanMinute: 'Менее минуты',
      inMinutes: 'Через {{count}} мин.',
      inHours: 'Через {{count}} ч.',
      inDays: 'Через {{count}} дн.',
    },
    preview: {
      type: 'Тип',
      groups: 'Группы',
      responsible: 'Ответственные',
      schedule: 'Расписание',
      deliveryEstimate: 'Оценка доставки',
      errors7d: 'Ошибки (7д)',
      minutes: '~{{count}} мин',
    },
    responsible: {
      selectChatsFirst: 'Выберите группы, чтобы назначить ответственных админов',
      hint: 'Админы групп, которые отвечают за это уведомление (необязательно)',
      noAdmins: 'В выбранных группах нет админов в системе',
      label: 'Ответственные админы',
    },
  },
  logs: {
    subtitle: 'Отправки и изменения настроек в одной ленте',
    chatFilter: 'Группа',
    period: 'Период',
    status: 'Статус',
    empty: 'Активности пока нет',
    emptyHint: 'Здесь появятся отправки и изменения',
  },
  activity: {
    changeBadge: 'Изменение',
    feed: {
      all: 'Всё',
      deliveries: 'Отправки',
      changes: 'Изменения',
    },
    roleChange: '{{from}} → {{to}}',
    health: {
      okTitle: 'Всё в порядке',
      okMessage: '{{sent}} успешных отправок за выбранный период',
      emptyTitle: 'Отправок пока нет',
      emptyMessage: 'За период ничего не отправлялось — создайте уведомление',
      pendingTitle: 'Есть ожидающие отправки',
      pendingMessage: '{{pending}} в очереди, {{sent}} уже отправлено',
      errorsTitle: 'Есть проблемы с доставкой',
      errorsMessage: '{{failed}} ошибок, {{sent}} успешных — проверьте ниже',
      viewErrors: 'Только ошибки',
    },
    actions: {
      reminder_created: 'Создано уведомление',
      reminder_updated: 'Обновлено уведомление',
      reminder_deleted: 'Удалено уведомление',
      reminder_paused: 'Уведомление приостановлено',
      reminder_resumed: 'Уведомление возобновлено',
      reminder_archived: 'Уведомление архивировано',
      chat_connected: 'Группа подключена',
      chat_disconnected: 'Группа отключена',
      member_role_changed: 'Изменена роль участника',
      integration_telegram_api_saved: 'Сохранены данные Telegram API',
      integration_telegram_api_removed: 'Удалены данные Telegram API',
      integration_telegram_api_verified: 'Telegram API проверен',
    },
  },
  audit: {
    empty: 'Записей аудита пока нет',
  },
  templates: {
    search: 'Поиск шаблонов...',
    namePlaceholder: 'Например, Daily standup',
    bodyPlaceholder: 'Текст шаблона...',
    createTitle: 'Создать шаблон',
    editTitle: 'Редактировать шаблон',
    empty: 'Шаблонов пока нет',
    createFirst: 'Создать первый шаблон',
    subtitle: 'Переиспользуемый текст для уведомлений',
    messageTemplates: 'Шаблоны сообщений',
    noTemplatesForChat: 'Нет шаблонов для этой группы.',
    emptyPicker: 'Шаблонов пока нет — создайте первый, чтобы подставлять текст в уведомления.',
    applyHint: 'Нажмите шаблон, чтобы подставить текст в сообщение.',
    createLink: 'Создать',
    allLink: 'Все →',
  },
  greetings: {
    placeholderHint: 'Переменные: {name}, {username}, {chat}',
    welcomeEnable: 'Включить welcome-сообщение',
    goodbyeEnable: 'Включить goodbye-сообщение',
    welcomeTitle: 'Welcome-сообщение',
    welcomeDescription: 'Отправляется, когда участник входит в группу',
    goodbyeTitle: 'Goodbye-сообщение',
    goodbyeDescription: 'Отправляется, когда участник выходит из группы',
  },
  timezones: {
    Europe_Kaliningrad: 'Калининград',
    Europe_Moscow: 'Москва',
    Europe_Samara: 'Самара',
    Asia_Yekaterinburg: 'Екатеринбург',
    Asia_Omsk: 'Омск',
    Asia_Krasnoyarsk: 'Красноярск',
    Asia_Irkutsk: 'Иркутск',
    Asia_Yakutsk: 'Якутск',
    Asia_Vladivostok: 'Владивосток',
    Asia_Magadan: 'Магадан',
    Asia_Kamchatka: 'Камчатка',
    Europe_Minsk: 'Минск',
    Asia_Almaty: 'Алматы',
    Asia_Tbilisi: 'Тбилиси',
    Asia_Baku: 'Баку',
    UTC: 'UTC',
  },
  quickCreate: {
    title: 'Быстрое создание',
    subtitle: 'Выберите режим — детали настроите на следующем шаге',
    now: 'Отправить сейчас',
    weekdays: 'По будням',
  },
  recurrence: {
    typeLabel: 'Повторение',
    whenLabel: 'Когда отправлять',
    intervalLabel: 'Повторять каждые',
    endsLabel: 'Заканчивать',
    summaryLabel: 'Итог',
    intervalUnit: {
      minute: 'минут',
      hour: 'часов',
      day: 'дней',
      week: 'недель',
      month: 'месяцев',
      year: 'лет',
    },
    types: {
      once: 'Один раз',
      daily: 'Каждый день',
      weekly: 'По дням недели',
      monthly: 'Каждый месяц',
      yearly: 'Каждый год',
      interval: 'Каждые N…',
    },
    ends: {
      never: 'Никогда',
      on_date: 'В дату',
      after_count: 'После N раз',
    },
    presets: {
      '15m': '15 мин',
      '30m': '30 мин',
      '1h': '1 час',
      '2h': '2 часа',
      '6h': '6 часов',
      '7d': '7 дней',
      '14d': '14 дней',
      '2w': '2 недели',
      '1m': 'Месяц',
      '2m': '2 месяца',
      '3m': 'Квартал',
      '6m': 'Полгода',
    },
    occurrences: 'Количество повторов',
    summary: {
      date: '{{date}}',
      once: 'Один раз, {{date}} в {{time}}',
      daily: 'Каждый день в {{time}}',
      weekly: 'Каждый {{days}} в {{time}}',
      monthly: 'Каждый месяц {{days}} числа в {{time}}',
      yearly: 'Каждый год {{day}} {{month}} в {{time}}',
      interval: 'Каждые {{interval}} {{unit}}, с {{start}}, в {{time}}',
    },
  },
  schedule: {
    weekdays: 'Дни недели',
    dayOfMonth: 'День месяца',
    daysOfMonth: 'Дни месяца',
    anchorMonth: 'Месяц начала цикла',
    month: 'Месяц',
    day: 'День',
    startDate: 'Дата отправки',
    endDate: 'Дата окончания',
    hasEndDate: 'Ограничить период повторения',
    intervalStart: 'Начать с даты',
    intervalDays: 'Повторять каждые N дней',
    time: 'Время',
    hours: 'Часы',
    minutes: 'Минуты',
    presets: {
      weekdays: 'Будни',
      weekend: 'Выходные',
      everyDay: 'Каждый день',
    },
    cycleHint: {
      bimonthly: 'Каждые 2 месяца, начиная с {{month}}',
      quarterly: 'Каждый квартал (каждые 3 мес.), начиная с {{month}}',
      semiannual: 'Каждые полгода, начиная с {{month}}',
    },
    types: {
      once: 'Один раз',
      daily: 'Ежедневно',
      weekly: 'По дням недели',
      monthly: 'Ежемесячно',
      bimonthly: 'Раз в 2 месяца',
      quarterly: 'Раз в квартал',
      semiannual: 'Раз в полгода',
      yearly: 'Ежегодно',
      interval: 'Раз в N дней',
    },
  },
  weekdays: {
    short: {
      '0': 'Вс',
      '1': 'Пн',
      '2': 'Вт',
      '3': 'Ср',
      '4': 'Чт',
      '5': 'Пт',
      '6': 'Сб',
    },
    long: {
      '0': 'Воскресенье',
      '1': 'Понедельник',
      '2': 'Вторник',
      '3': 'Среда',
      '4': 'Четверг',
      '5': 'Пятница',
      '6': 'Суббота',
    },
  },
  months: {
    '1': 'Январь',
    '2': 'Февраль',
    '3': 'Март',
    '4': 'Апрель',
    '5': 'Май',
    '6': 'Июнь',
    '7': 'Июль',
    '8': 'Август',
    '9': 'Сентябрь',
    '10': 'Октябрь',
    '11': 'Ноябрь',
    '12': 'Декабрь',
  },
} as const;

type DeepStringMap<T> = T extends string
  ? string
  : T extends Record<string, unknown>
    ? { [K in keyof T]: DeepStringMap<T[K]> }
    : never;

export type TranslationTree = DeepStringMap<typeof ru>;
